/**
 * SPA entry point. Sets up:
 *   - React 18 root
 *   - BrowserRouter (client-side routing)
 *   - QueryClientProvider (react-query cache for /api/admin/* calls)
 *
 * Routes are defined inside <App /> so route-level providers can sit
 * underneath the router context.
 */

import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

import App from "./App";
import "./index.css";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Devices/heartbeats are written by the device daemon every 5 minutes.
      // 30s is a comfortable freshness window for the operator dashboard
      // without hammering the Workers API.
      staleTime: 30_000,
      refetchOnWindowFocus: false,
      retry: 1,
    },
    mutations: {
      retry: 0,
    },
  },
});

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>,
);
